export default "__VITE_ASSET__DMqOHFzX__"